import { LitElement, html, unsafeCSS, CSSResult } from 'lit';
import { property } from 'lit/decorators.js';
import { literal } from 'lit/static-html.js';
import { C11nPrefix, C11nPrefixLiteral } from 'virtual:c11n-prefix';
import styles from './link.scss?inline';
import slotStyles from './link.slot.scss?inline';
import { appendStylesheet, c11nElement } from '../core';

@c11nElement()
export class LinkComponent extends LitElement {
  static selector = `${C11nPrefix}-link`;
  static literal = literal`${C11nPrefixLiteral}-link`;
  static override styles: CSSResult = unsafeCSS(styles);

  @property({ attribute: 'c11n-web-link', type: Boolean, reflect: true })
  readonly _c11n_web_link: boolean = true;

  override connectedCallback(): void {
    super.connectedCallback();
    this.appendStyles();
  }

  appendStyles() {
    const slotStylesheet: string = slotStyles.toString()
      .replaceAll(/\bc11n-web-link\b/g, this.tagName.toLowerCase());
    appendStylesheet({ 
      target: this as Node, 
      styles: slotStylesheet, 
      name: `${this.tagName.toLowerCase()}-slot`
    });
  }

  override render() {
    return html`<slot></slot>`;
  }
}
export const C11nLink = LinkComponent.selector;
export const C11nLinkLiteral = LinkComponent.literal;
